import { Card, CardHeader } from "@mui/material";
import { EventsWeeklyHeatMap } from "../../components/EventsWeeklyHeatmap/EventsWeeklyHeatMap";
import { DisplayFormat } from "../../components/EventsWeeklyHeatmap/configs";
import { MatchFilter } from "../../libs/statsFilters";

export type EnigmaEventWeeklyHeatmapProps = {
  cityEscapeId?: string | null;
  enigmaId?: string; 
  filters?: MatchFilter
};

export function EnigmaEventWeeklyHeatmap({
  cityEscapeId,
  enigmaId,
  filters
}: EnigmaEventWeeklyHeatmapProps) {
  return (
    <Card>
      <CardHeader title="Distribuzione Settimanale Eventi" />
      <EventsWeeklyHeatMap
        cityEscapeId={cityEscapeId}
        enigmaId={enigmaId}
        filters={filters}
        trimEmptyHours={true}
        displayFormat={DisplayFormat.PERCENTAGE_TOTAL}
        loading={false}
      />
    </Card>
  );
}
